// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

import {DateTime} from 'docs/markdoc/attribute-types';

export const Callout: MarkdocTagRegistration = {
  tag: 'callout',
  component: 'Callout',
  description: 'Display the enclosed content in a callout box',
  children: ['paragraph', 'tag', 'list'],
  attributes: {
    type: {
      type: String,
      default: 'note',
      matches: ['caution', 'check', 'note', 'warning'],
      errorLevel: 'critical',
      description:
        'Controls the color and icon of the callout. Can be: "caution", "check", "note", "warning"',
    },
    title: {
      type: String,
      description: 'The title displayed at the top of the callout',
      localizable: true,
    },
    until: {
      type: DateTime,
      description: 'Show the callout until the specified date',
    },
  },
};
